/**
 * Escapes HTML special characters to HTML entities
 */
function escapeHTML(str: string): string {
    return str.replace(/&/gm, "&amp;")
        .replace(/</gm, "&lt;")
        .replace(/>/gm, "&gt;")
        .replace(/"/gm, "&quot;")
        .replace(/'/gm, "&apos;");
}

/**
 * Unescapes HTML special characters to HTML entities
 */
function unescapeHTML(str: string): string {
    return str.replace(/&apos;/gm, "'")
        .replace(/&quot;/gm, '"')
        .replace(/&gt;/gm, ">")
        .replace(/&lt;/gm, "<")
        .replace(/&amp;/gm, "&");
}

/**
 * Escapes certain HTML special characters for use in Markdown:
 * - Opening angle bracket (<) if not within a code block
 * - Closing angle bracket (>) if not at the beginning of a line and not within a code block
 */
function escapeMarkdown(str: string): string {
    // Use (`[^`]*`) to capture code blocks as a group and if the group is present, don't replace.
    return str.replace(/(`[^`]*`)|</gm, (_, p) => p || "&lt;")
        .replace(/(`[^`]*`)|(?!^)>/gm, (_, p) => p || "&gt;");
}

/**
 * Escapes Android special characters to empty string
 */
function escapeAndroidXML(str: string): string {
    return escapeHTML(str).replace(/^@/gm, "\\ufeff@");
}

/**
 * Escapes special characters so that they are safe to use in regular expressions
 */
// Taken from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
function escapeRegExp(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

/**
 * Escapes special characters except for asterisk, so that they are safe to use in regular expressions
 */
function escapeRegExpButAsterisk(str: string): string {
    return str.replace(/[.+\-?^${}()|[\]\\]/g, "\\$&");
}

export {
    escapeHTML,
    unescapeHTML,
    escapeMarkdown,
    escapeAndroidXML,
    escapeRegExp,
    escapeRegExpButAsterisk
};
